import gsap from "gsap";
import { disablePageScroll, enablePageScroll } from "scroll-lock";

function toggleWebtip() {
  $('button.webtip').on('click', function () {
    let dataId = $(this).data('id');
    $('.popup-webtip-bg, .popup-webtip[data-id="' + dataId + '"]').addClass('active');
    if ($(window).width() <= 600) {
      disablePageScroll();
    } 
  });

  $('.popup-webtip-close, .popup-webtip-button').on('click', function () {
    closePopup();
    if ($(window).width() <= 600) {
      enablePageScroll();
    } 
  });

  $('.popup-webtip-bg').on('click', function () {
    closePopup();
    if ($(window).width() <= 600) {
      enablePageScroll();
    } 
  });

  function closePopup() {
    let popup = $('.popup-webtip.active');
    if (!popup.length) return;
    $('.popup-webtip, .popup-webtip-bg').removeClass('active');
  }

  // Переменные для отслеживания свайпа
  let startY = 0;
  let endY = 0;

  const swipeThreshold = 100; // Увеличиваем порог на 100px

  // Слушаем касания (для мобильных устройств)
  $(document).on('touchstart', function(event) {
    // Запоминаем начальную позицию касания
    startY = event.touches[0].pageY;

    // Проверяем, был ли клик в .popup-webtip-content
    if ($(event.target).closest('.popup-webtip-content').length) {
      return; // Если касание произошло внутри .popup-webtip-content, не отслеживаем свайп
    }
  });

  $(document).on('touchmove', function(event) {
    // Запоминаем конечную позицию касания
    endY = event.touches[0].pageY;
  });

  $(document).on('touchend', function(event) {
    if (startY < endY && (endY - startY) > swipeThreshold) { // Если свайп вниз и больше 100px
      // Закрываем попап при свайпе вниз
      if (!$(event.target).closest('.popup-webtip-content').length) {
        $('.popup-webtip').removeClass('active');
        $('.popup-webtip-bg').removeClass('active');
      }
    }
  });
}

toggleWebtip();


function adjustPopupHeight() {
  $('.popup-webtip-content').each(function () {
    let content = $(this);
    let popup = content.closest('.popup-webtip');
    let maxPopupHeight = $(window).height() * 0.95;
    let initialHeight = popup.outerHeight();

    content.on('scroll', function () {
      let scrollTop = content.scrollTop();
      let newHeight = initialHeight + scrollTop;
      if (newHeight > maxPopupHeight) {
        newHeight = maxPopupHeight;
      }
      gsap.to(popup, {maxHeight: newHeight + 'px'});
    });
  });
}

let popup = $('.popup-webtip');
if ($(window).width() <= 600) {
  adjustPopupHeight();
} else {
  gsap.to(popup, {maxHeight: 'calc(100dvh - 40px)'});
}
